/** The billing zip of Other's own carrier accounts. Shown after the account
 *  number wherever the vendor reads "bill to Other's … account" (Stephanie
 *  2026-10-27: "so the vendor knows the zip code for that account"). Never
 *  added to a client's account. */
export const OTHER_SHIPPING_ACCOUNT_ZIP = "33434";
